import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Webcam from "react-webcam";
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Button,
    Form,
    Input,
    InputGroup,
    Modal,
    ModalHeader,
    ModalBody,

} from "reactstrap";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";
import { getTodaysVisitsByClinicId2, getClinic, getPCAREByVisitId, addTakeFrame, getJob, searchFrameByFcode } from "service/api";


const cardTopStyle = {
    backgroundColor: "#DC4C64",
    padding: "4px",
    color: "white",
    height: "30px",
}

const TakeFrames = () => {
    const [takeFrmae, setakeFrmae] = useState({});
    const [webcamImage, setWebcamImage] = useState(null);
    const [frameCaptureModal, setFrameCaptureModal] = useState(false);

    const [allvisit, setAllvisit] = useState([]);
    const [selectedVisit, setSelectedVisit] = useState(null);
    const [clinicIdFromToken, setClinicIdFromToken] = useState(null);
    const [allcliniclist, setAllcliniclist] = useState([]);
    const [selectedClinic, setSelectedClinic] = useState("");
    const [loadingPcare, setLoadingPcare] = useState(false);
    const [pcareFound, setPcareFound] = useState(false);

    const webcamRef = useRef(null);

    const [saving, setSaving] = useState(false);

    // ── Registered Job mode ──
    const [hasRegisteredJob, setHasRegisteredJob] = useState(false);
    const [allJobs, setAllJobs] = useState([]);
    const [selectedJob, setSelectedJob] = useState(null);
    const [jobClinicId, setJobClinicId] = useState(null);
    const [frameCodeQuery, setFrameCodeQuery] = useState("");
    const [frameSearchResults, setFrameSearchResults] = useState([]);
    const [frameSearchLoading, setFrameSearchLoading] = useState(false);
    const [frameSearchOpen, setFrameSearchOpen] = useState(false);
    const frameSearchRef = useRef(null);

    // ── Fetch jobs when job toggle is switched on ──
    useEffect(() => {
        if (hasRegisteredJob && allJobs.length === 0) {
            getJob().then(res => setAllJobs(res?.data || [])).catch(() => { });
        }
    }, [hasRegisteredJob]);

    // ── Decode token — admin has no clinicID, clinic login has clinicID ──
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setClinicIdFromToken(decoded?.clinicID || null);
            } catch (e) { /* ignore */ }
        }
    }, []);

    // ── Job toggle ──
    const handleJobToggle = (e) => {
        const checked = e.target.checked;
        setHasRegisteredJob(checked);
        setSelectedJob(null);
        setJobClinicId(null);
        setFrameCodeQuery("");
        setFrameSearchResults([]);
        setFrameSearchOpen(false);
        if (!checked) {
            setSelectedVisit(null);
            setPcareFound(false);
            setakeFrmae({});
            setWebcamImage(null);
        }
    };

    const handleJobSelect = (selected) => {
        setSelectedJob(selected);
        setFrameCodeQuery("");
        setFrameSearchResults([]);
        setFrameSearchOpen(false);
        if (selected) {
            const j = selected.job;
            const cId = j.patientID?.clinicname?._id || clinicIdFromToken || null;
            setJobClinicId(cId);
        } else {
            setJobClinicId(null);
        }
    };

    // ── Admin: fetch clinic list ──
    useEffect(() => {
        if (!clinicIdFromToken) {
            getClinic().then(res => setAllcliniclist(res.data || [])).catch(() => { });
        }
    }, [clinicIdFromToken]);

    // ── Clinic login: auto-fetch visits for their clinic ──
    useEffect(() => {
        if (clinicIdFromToken) {
            fetchVisitsByClinic(clinicIdFromToken);
        }
    }, [clinicIdFromToken]);

    const fetchVisitsByClinic = async (clinicId) => {
        try {
            const res = await getTodaysVisitsByClinicId2(clinicId);
            setAllvisit(res?.data || []);
        } catch (e) {
            setAllvisit([]);
        }
    };

    useEffect(() => {
        const handler = (e) => {
            if (frameSearchRef.current && !frameSearchRef.current.contains(e.target)) {
                setFrameSearchOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    // ── Admin: when clinic selected from dropdown ──
    const handleClinicChange = (e) => {
        const clinicId = e.target.value;
        setSelectedClinic(clinicId);
        setAllvisit([]);
        setSelectedVisit(null);
        setPcareFound(false);
        if (clinicId) fetchVisitsByClinic(clinicId);
    };

    // ── When visit selected, fetch patient care and auto-populate ──
    const handleVisitChange = async (selected) => {
        setSelectedVisit(selected);
        setPcareFound(false);
        if (!selected) return;

        setLoadingPcare(true);
        try {
            const res = await getPCAREByVisitId(selected.value);
            const pcareList = res.data;
            if (pcareList && pcareList.length > 0) {
                const pcare = pcareList[0];
                setakeFrmae({
                    frame_brand: pcare.frame_brand || "",
                    frame_code: pcare.frame_code || "",
                    frame_id: pcare.frame_id || "",
                    frame_color: pcare.frame_color || "",
                    frame_size: pcare.frame_size || "",
                    price: pcare.price || "",
                    frame_material: pcare.frame_material || "",
                    frame_type: pcare.frame_type || "",
                    frame_shape: pcare.frame_shape || "",
                    frame_image: pcare.frame_image || null,
                });
                if (pcare.frame_image) setWebcamImage(pcare.frame_image);
                setPcareFound(true);
            } else {
                // No patient care record — clear fields
                setakeFrmae({});
                setWebcamImage(null);
            }
        } catch (e) {
            setakeFrmae({});
            setWebcamImage(null);
        } finally {
            setLoadingPcare(false);
        }
    };

    const captureImage = () => {
        const imageSrc = webcamRef.current.getScreenshot();
        setWebcamImage(imageSrc);
        setakeFrmae(prev => ({ ...prev, frame_image: imageSrc }));
        setFrameCaptureModal(false);
    };

    const onValueChange = (e) => {
        setakeFrmae(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleFrameCodeSearch = async (query) => {
        setFrameCodeQuery(query);

        if (!selectedJob) {
            setFrameSearchResults([]);
            setFrameSearchOpen(false);
            if (query.trim()) {
                toast.info("Please select Job Reference first before searching frame.", {
                    position: "top-center",
                    autoClose: 1500,
                });
            }
            return;
        }

        const clinicId = jobClinicId || clinicIdFromToken || "";
        if (!clinicId) {
            setFrameSearchResults([]);
            setFrameSearchOpen(false);
            return;
        }

        if (!query.trim()) {
            setFrameSearchResults([]);
            setFrameSearchOpen(false);
            return;
        }

        setFrameSearchLoading(true);
        try {
            const res = await searchFrameByFcode(query.trim(), clinicId);
            setFrameSearchResults(res.data || []);
            setFrameSearchOpen(true);
        } catch (error) {
            console.error("Frame search error:", error);
            setFrameSearchResults([]);
            setFrameSearchOpen(true);
        } finally {
            setFrameSearchLoading(false);
        }
    };

    const handleFrameCodeSelect = (stockItem) => {
        const frameDoc = stockItem.fname_id;
        if (!frameDoc) return;

        setakeFrmae(prev => ({
            ...prev,
            frame_brand: frameDoc.frame_name || "",
            frame_code: stockItem.fcode || "",
            frame_id: frameDoc._id || "",
            frame_color: frameDoc.frame_color || "",
            frame_size: frameDoc.frame_size || "",
            price: frameDoc.price || "",
            frame_material: frameDoc.frame_material || "",
            frame_type: frameDoc.frame_type || "",
            frame_shape: frameDoc.frame_shape || "",
        }));

        setFrameCodeQuery(stockItem.fcode || "");
        setFrameSearchResults([]);
        setFrameSearchOpen(false);
    };

    const handleSave = async () => {
        if (hasRegisteredJob) {
            if (!selectedJob) { toast.error("Please select a registered job."); return; }
            setSaving(true);
            try {
                const clinicId = jobClinicId || clinicIdFromToken || undefined;
                const payload = {
                    ...takeFrmae,
                    ...(clinicId ? { clinic_id: clinicId } : {}),
                    visit_no: selectedJob.job?.vc_reference || "",
                    job_id: selectedJob.value,
                    job_vc_reference: selectedJob.job?.vc_reference || "",
                };
                if (!payload.frame_id) delete payload.frame_id;
                await addTakeFrame(payload);
                toast.success("Frame record saved successfully!");
                setakeFrmae({});
                setWebcamImage(null);
                setSelectedJob(null);
                setJobClinicId(null);
            } catch (e) {
                toast.error("Failed to save frame record.");
            } finally {
                setSaving(false);
            }
            return;
        }

        if (!selectedVisit) {
            toast.error("Please select a visit first.");
            return;
        }
        const clinicId = clinicIdFromToken || selectedClinic;
        if (!clinicId) {
            toast.error("Please select a practice.");
            return;
        }
        setSaving(true);
        try {
            const payload = {
                ...takeFrmae,
                clinic_id: clinicId,
                visit_id: selectedVisit.value,
                visit_no: selectedVisit.label.split(" — ")[0],
            };
            if (!payload.frame_id) delete payload.frame_id;
            await addTakeFrame(payload);
            toast.success("Frame record saved successfully!");
            setakeFrmae({});
            setWebcamImage(null);
            setSelectedVisit(null);
            setPcareFound(false);
        } catch (e) {
            toast.error("Failed to save frame record.");
        } finally {
            setSaving(false);
        }
    };

    const visitOptions = allvisit.map(v => ({
        value: v._id,
        label: `${v.visit_no}${v.patientid ? " — " + (v.patientid.firstname || "") + " " + (v.patientid.lastname || "") : ""}`,
    }));

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="page-title">Frame Selection</h4>
                        <Link to="/list-takeframe" className="btn btn-danger">
                            <i className="mdi mdi-format-list-bulleted me-1" />List
                        </Link>
                    </div>

                    <Row>
                        <Card>
                            <CardBody>

                                {/* ── Registered Job Toggle ── */}
                                <Row className="mb-3">
                                    <Col md={12}>
                                        <div className="d-flex align-items-center" style={{ padding: "6px 0" }}>
                                            <div className="form-check form-switch mb-0">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="frameJobToggle"
                                                    checked={hasRegisteredJob}
                                                    onChange={handleJobToggle}
                                                    style={{ width: 40, height: 20, cursor: "pointer" }}
                                                />
                                                <label className="form-check-label ms-2" htmlFor="frameJobToggle" style={{ fontSize: 14, fontWeight: 600 }}>
                                                    Do you have a registered job?
                                                </label>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                                {hasRegisteredJob ? (
                                    <>
                                        <div style={cardTopStyle}>
                                            <CardTitle className="mb-0">Select Registered Job</CardTitle>
                                        </div>
                                        <br />
                                        <Row className="mb-4">
                                            <Col md={5}>
                                                <Label>Job Reference</Label>
                                                <Select
                                                    options={allJobs.map(j => ({
                                                        value: j._id,
                                                        label: `${j.vc_reference || j._id} — ${j.patient_name || ""}`,
                                                        job: j,
                                                    }))}
                                                    value={selectedJob}
                                                    onChange={handleJobSelect}
                                                    placeholder="Search by job reference or patient name..."
                                                    isClearable
                                                />
                                            </Col>
                                            {selectedJob && (
                                                <Col md={5} className="d-flex align-items-end">
                                                    <span className="text-success" style={{ fontSize: 13, fontWeight: 600 }}>
                                                        <i className="mdi mdi-briefcase-check me-1" />
                                                        Job: {selectedJob.job?.vc_reference} &nbsp;|&nbsp; Practice: {selectedJob.job?.practisc_name || "—"}
                                                    </span>
                                                </Col>
                                            )}
                                        </Row>
                                    </>
                                ) : (
                                    <>
                                        {/* ── Visit Search ── */}
                                        <div style={cardTopStyle}>
                                            <CardTitle className="mb-0">Select Visit</CardTitle>
                                        </div>
                                        <br />
                                        <Row className="mb-4">
                                            {!clinicIdFromToken && (
                                                <Col md={4}>
                                                    <Label>Practice</Label>
                                                    <select
                                                        className="form-control"
                                                        value={selectedClinic}
                                                        onChange={handleClinicChange}
                                                    >
                                                        <option value="">Select Practice</option>
                                                        {allcliniclist.map(c => (
                                                            <option key={c._id} value={c._id}>{c.name}</option>
                                                        ))}
                                                    </select>
                                                </Col>
                                            )}
                                            <Col md={4}>
                                                <Label>Visit No.</Label>
                                                <Select
                                                    options={visitOptions}
                                                    value={selectedVisit}
                                                    onChange={handleVisitChange}
                                                    placeholder={!clinicIdFromToken && !selectedClinic ? "Select a practice first..." : "Search and select visit..."}
                                                    isClearable
                                                    isDisabled={!clinicIdFromToken && !selectedClinic}
                                                />
                                            </Col>
                                            <Col md={4} className="d-flex align-items-end">
                                                {loadingPcare && (
                                                    <span className="text-muted" style={{ fontSize: 13 }}>
                                                        <span className="spinner-border spinner-border-sm me-1" />
                                                        Loading patient care data...
                                                    </span>
                                                )}
                                                {!loadingPcare && pcareFound && (
                                                    <span className="text-success" style={{ fontSize: 13, fontWeight: 600 }}>
                                                        <i className="mdi mdi-check-circle me-1" />
                                                        Frame data auto-populated from patient care record
                                                    </span>
                                                )}
                                                {!loadingPcare && selectedVisit && !pcareFound && (
                                                    <span className="text-warning" style={{ fontSize: 13 }}>
                                                        <i className="mdi mdi-alert-outline me-1" />
                                                        No patient care record found for this visit
                                                    </span>
                                                )}
                                            </Col>
                                        </Row>
                                    </>
                                )}

                                {/* ── Frame Details Form ── */}
                                <div style={cardTopStyle}>
                                    <CardTitle className="mb-0">Frame Details</CardTitle>
                                </div>
                                <br />
                                <Form>
                                    {hasRegisteredJob && (
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-3" ref={frameSearchRef} style={{ position: "relative" }}>
                                                    <Label style={{ fontWeight: 600, fontSize: 13 }}>
                                                        <i className="mdi mdi-barcode-scan me-1" style={{ color: "#DC4C64" }} />
                                                        Search Frame by Code
                                                        <span style={{ fontSize: 11, color: "#999", fontWeight: 400, marginLeft: 6 }}>(from frame stock by job practice)</span>
                                                    </Label>
                                                    <div style={{ position: "relative" }}>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder={selectedJob ? "Type frame code or frame name" : "Select Job Reference first"}
                                                            value={frameCodeQuery}
                                                            onChange={(e) => handleFrameCodeSearch(e.target.value)}
                                                            disabled={!selectedJob}
                                                            style={{ paddingRight: 36, fontSize: 13, borderColor: "#DC4C64", borderRadius: 6 }}
                                                        />
                                                        {frameSearchLoading && (
                                                            <span style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", fontSize: 14, color: "#DC4C64" }}>
                                                                <i className="mdi mdi-loading mdi-spin" />
                                                            </span>
                                                        )}
                                                        {frameCodeQuery && !frameSearchLoading && (
                                                            <span
                                                                onClick={() => {
                                                                    setFrameCodeQuery("");
                                                                    setFrameSearchResults([]);
                                                                    setFrameSearchOpen(false);
                                                                }}
                                                                style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", fontSize: 18, color: "#bbb", cursor: "pointer", lineHeight: 1 }}
                                                            >
                                                                ×
                                                            </span>
                                                        )}
                                                    </div>
                                                    {!selectedJob && (
                                                        <div style={{ fontSize: 11, color: "#DC4C64", marginTop: 6 }}>
                                                            Please select Job Reference before searching frame stock.
                                                        </div>
                                                    )}
                                                    {frameSearchOpen && (
                                                        <div
                                                            style={{
                                                                position: "absolute",
                                                                top: "100%",
                                                                left: 0,
                                                                right: 0,
                                                                background: "#fff",
                                                                border: "1px solid #eee",
                                                                borderRadius: 8,
                                                                boxShadow: "0 8px 24px rgba(0,0,0,.08)",
                                                                zIndex: 50,
                                                                marginTop: 6,
                                                                maxHeight: 260,
                                                                overflowY: "auto",
                                                            }}
                                                        >
                                                            {frameSearchResults.length > 0 ? (
                                                                frameSearchResults.map((stockItem) => (
                                                                    <div
                                                                        key={stockItem._id}
                                                                        onClick={() => handleFrameCodeSelect(stockItem)}
                                                                        style={{
                                                                            padding: "10px 12px",
                                                                            borderBottom: "1px solid #f5f5f5",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        <div style={{ fontWeight: 700, fontSize: 13, color: "#333" }}>
                                                                            {stockItem.fcode || "No Code"}
                                                                        </div>
                                                                        <div style={{ fontSize: 12, color: "#666", marginTop: 2 }}>
                                                                            {stockItem.fname_id?.frame_title || stockItem.fname_id?.frame_name || stockItem.fname}
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <div style={{ padding: "10px 12px", fontSize: 12, color: "#999" }}>
                                                                    No frame found for this practice
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                    <Row>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-framecolor-Input">Frame Brand :</Label>
                                                <Input
                                                    type="text"
                                                    className="form-control"
                                                    name="frame_brand"
                                                    value={takeFrmae.frame_brand || ""}
                                                    placeholder="Frame Brand"
                                                    onChange={e => onValueChange(e)}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-framecolor-Input">Frame Color :</Label>
                                                <Input
                                                    type="text"
                                                    className="form-control"
                                                    name="frame_color"
                                                    value={takeFrmae.frame_color || ""}
                                                    placeholder="Frame Color"
                                                    onChange={e => onValueChange(e)}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-size-Input">Size :</Label>
                                                <Input
                                                    type="text"
                                                    className="form-control"
                                                    name="frame_size"
                                                    value={takeFrmae.frame_size || ""}
                                                    placeholder="Frame Size"
                                                    onChange={e => onValueChange(e)}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-price-Input">Price :</Label>
                                                <Input
                                                    type="number"
                                                    className="form-control"
                                                    name="price"
                                                    value={takeFrmae.price || ""}
                                                    placeholder="Price"
                                                    onChange={e => onValueChange(e)}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-size-Input">Material :</Label>
                                                <select
                                                    name="frame_material"
                                                    className="form-control"
                                                    value={takeFrmae.frame_material || ""}
                                                    onChange={e => onValueChange(e)}
                                                >
                                                    <option value="">Select</option>
                                                    <option>Acetate</option>
                                                    <option>Titanium</option>
                                                    <option>Nylon</option>
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-size-Input">Type :</Label>
                                                <select
                                                    name="frame_type"
                                                    className="form-control"
                                                    value={takeFrmae.frame_type || ""}
                                                    onChange={e => onValueChange(e)}
                                                >
                                                    <option value="">Select</option>
                                                    <option>Full Rim</option>
                                                    <option>Semi-rimless</option>
                                                    <option>Rimless</option>
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-size-Input">Shape :</Label>
                                                <select
                                                    name="frame_shape"
                                                    className="form-control"
                                                    value={takeFrmae.frame_shape || ""}
                                                    onChange={e => onValueChange(e)}
                                                >
                                                    <option value="">Select</option>
                                                    <option>Rectangle</option>
                                                    <option>cat-eye</option>
                                                    <option>Round</option>
                                                    <option>Oval</option>
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="mb-3">
                                                <Label>Take Photo :</Label>
                                                <div className="d-flex align-items-center gap-2">
                                                    <Button
                                                        color="light"
                                                        onClick={() => setFrameCaptureModal(true)}
                                                        style={{ border: "1px solid #dee2e6", fontSize: "22px", padding: "4px 10px" }}
                                                        title="Open Camera"
                                                    >
                                                        📷
                                                    </Button>
                                                    {webcamImage && (
                                                        <img
                                                            src={webcamImage}
                                                            alt="Captured"
                                                            style={{ width: "48px", height: "48px", borderRadius: "50%", objectFit: "cover", border: "2px solid #DC4C64" }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    <div className="mt-2">
                                        <button
                                            className="btn btn-danger px-4"
                                            onClick={handleSave}
                                            disabled={saving}
                                        >
                                            {saving
                                                ? <><span className="spinner-border spinner-border-sm me-1" />Saving...</>
                                                : <><i className="mdi mdi-content-save me-1" />Save</>
                                            }
                                        </button>
                                    </div>
                                </Form>

                            </CardBody>
                        </Card>
                    </Row>

                    <Modal isOpen={frameCaptureModal} toggle={() => setFrameCaptureModal(!frameCaptureModal)} size="lg">
                        <ModalHeader toggle={() => setFrameCaptureModal(false)}>
                            Capture Frame Image
                        </ModalHeader>
                        <ModalBody>
                            <div className="d-flex flex-column align-items-center">
                                <Webcam
                                    audio={false}
                                    ref={webcamRef}
                                    screenshotFormat="image/jpeg"
                                    width={500}
                                    height={350}
                                    videoConstraints={{ facingMode: "user" }}
                                />
                                <Button color="primary" className="mt-3" onClick={captureImage}>
                                    Capture
                                </Button>
                            </div>
                            {webcamImage && (
                                <div className="text-center mt-3">
                                    <p>Captured Image:</p>
                                    <img src={webcamImage} alt="Captured" className="img-fluid" />
                                </div>
                            )}
                        </ModalBody>
                    </Modal>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default TakeFrames
